module.exports = __webpack_public_path__ + "img/app_store_steps.dbd64beb.jpg";